// Google Tag Manager Tracking Utilities

/**
 * Track form submission events to GTM
 * @param {string} formType - Type of form (e.g., 'bewertung', 'contact')
 * @param {object} additionalData - Additional data to track
 */
export const trackFormSubmission = (formType, additionalData = {}) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'form_submission',
      form_type: formType,
      ...additionalData,
    });
  }
};

/**
 * Track CTA button clicks
 * @param {string} ctaName - Name of the CTA button
 * @param {string} ctaLocation - Location of the CTA (e.g., 'header', 'hero', 'footer')
 */
export const trackCTAClick = (ctaName, ctaLocation) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'cta_click',
      cta_name: ctaName,
      cta_location: ctaLocation,
    });
  }
};

/**
 * Track page views with UTM parameters
 * @param {string} pagePath - The page path
 */
export const trackPageView = (pagePath) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    const urlParams = new URLSearchParams(window.location.search);
    
    window.dataLayer.push({
      event: 'page_view',
      page_path: pagePath,
      utm_source: urlParams.get('utm_source') || '(direct)',
      utm_medium: urlParams.get('utm_medium') || '(none)',
      utm_campaign: urlParams.get('utm_campaign') || '(not set)',
      utm_term: urlParams.get('utm_term') || '',
      utm_content: urlParams.get('utm_content') || '',
      gclid: urlParams.get('gclid') || '', // Google Ads Click ID
    });
  }
};

/**
 * Get UTM parameters from URL
 * @returns {object} UTM parameters object
 */
export const getUTMParams = () => {
  if (typeof window !== 'undefined') {
    const urlParams = new URLSearchParams(window.location.search);
    return {
      utm_source: urlParams.get('utm_source') || '',
      utm_medium: urlParams.get('utm_medium') || '',
      utm_campaign: urlParams.get('utm_campaign') || '',
      utm_term: urlParams.get('utm_term') || '',
      utm_content: urlParams.get('utm_content') || '',
      gclid: urlParams.get('gclid') || '',
    };
  }
  return {};
};

/**
 * Track Heyflow form start
 */
export const trackHeyflowStart = () => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'heyflow_start',
      form_type: 'bewertung',
    });
  }
};

/**
 * Track Heyflow form completion
 * This should be called from Heyflow webhook or custom event
 */
export const trackHeyflowCompletion = (data = {}) => {
  if (typeof window !== 'undefined' && window.dataLayer) {
    window.dataLayer.push({
      event: 'heyflow_completion',
      event_category: 'form',
      event_label: 'bewertung_completed',
      ...data,
    });
  }
};

export default {
  trackFormSubmission,
  trackCTAClick,
  trackPageView,
  getUTMParams,
  trackHeyflowStart,
  trackHeyflowCompletion,
};
